module.exports = __webpack_public_path__ + "static/media/banner-phone-contakt.453bcdac.jpg";